import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Modal from "react-modal";
import Content from "./Content";
import CloseViewer from "../CloseViewer";
import { closeDisplayAlbum, setSelectedMedia } from "Actions";
import _ from "i18n";

const customStyles = {
  content: {
    backgroundColor: "#fff",
    border: "none",
    overflow: "none",
    padding: 0,
    top: "5%",
    left: "5%",
    right: "5%",
    bottom: "5%",
    borderRadius: "5px",
    boxShadow: "0px 0px 10px rgba(41, 57, 77, 0.04)"
  }
};
class DisplayAlbum extends Component {
  state = {
    isOpen: true
  };

  closeModal = () => {
    // const { resetMediaEditor } = this.props;
    // this.setState({ savingState: "default", savingError: null });
    // setTimeout(e => {
    //   if (this.editor) {
    //     this.editor.destroy();
    //     this.editor = null;
    //   }
    //   resetMediaEditor();
    // });
  };

  afterOpenModal = () => {};

  render() {
    const {
      isOpen,
      currentAlbum,
      closeDisplayAlbum,
      setSelectedMedia,
      selectedMedia,
      language,
      fetching
    } = this.props;

    return (
      <Modal
        isOpen={isOpen}
        onAfterOpen={this.afterOpenModal}
        onRequestClose={this.closeModal}
        closeTimeoutMS={500}
        style={customStyles}
        contentLabel="Album Viewer"
      >
        <div className="rmodal" id="displayAlbum">
          <CloseViewer closeViewer={closeDisplayAlbum} />
          <Content
            currentAlbum={currentAlbum}
            selectedMedia={selectedMedia}
            language={language}
            fetching={fetching}
            setSelectedMedia={setSelectedMedia}
          />
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  isOpen: state.displayAlbum.isOpen,
  currentAlbum: state.displayAlbum.currentAlbum,
  fetching: state.displayAlbum.fetching,
  selectedMedia: state.displayAlbum.selectedMedia,
  language: state.params.lng
});

const mapDispatchToProps = dispatch => ({
  closeDisplayAlbum: () => dispatch(closeDisplayAlbum()),
  setSelectedMedia: media => dispatch(setSelectedMedia(media))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DisplayAlbum);



// WEBPACK FOOTER //
// ./src/components/Reveal/DisplayAlbum/index.js